import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "filter-section flex flex-row justify-between" }
const _hoisted_2 = {
  key: 1,
  class: "w-full mt-2"
}
const _hoisted_3 = {
  key: 3,
  class: "p-field-checkbox flex flex-row ml-4"
}
const _hoisted_4 = {
  for: "mixpack",
  class: "ml-3 pt-4 font-montserrat text-gray-lp-300 text-12px xxl:text-14px"
}
const _hoisted_5 = {
  key: 4,
  class: "p-field-checkbox flex flex-row ml-4"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "mixpack",
  class: "ml-3 pt-4 font-montserrat text-gray-lp-300 text-12px xxl:text-14px"
}, "L1", -1)
const _hoisted_7 = {
  key: 5,
  class: "p-field-checkbox flex flex-row ml-4"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "mixpack",
  class: "ml-3 pt-4 font-montserrat text-gray-lp-300 text-12px xxl:text-14px"
}, "DEL", -1)
const _hoisted_9 = {
  key: 6,
  class: "p-field-checkbox flex flex-row ml-4"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "mixpack",
  class: "ml-3 pt-4 font-montserrat text-gray-lp-300 text-12px xxl:text-14px"
}, "RTS", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      (!_ctx.isConsole)
        ? (_openBlock(), _createBlock(_component_LpButton, {
            key: 0,
            textColor: "white",
            title: "Ambil Tiket DEX",
            fontWeight: "semibold",
            onClick: _ctx.takeTicketDex
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", {
      class: 
        `w-1/2 flex flex-row items-center ${_ctx.isAgentDexL2 ? '' : 'justify-end'}`
      
    }, [
      (!_ctx.isAgentDexL1)
        ? (_openBlock(), _createBlock(_component_Search, {
            key: 0,
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch,
            value: _ctx.searchValue,
            class: "w-full mt-2",
            placeholder: _ctx.$t('dexAssessment.searchPlaceholder')
          }, null, 8, ["onInput", "onClear", "value", "placeholder"]))
        : _createCommentVNode("", true),
      (_ctx.isConsole)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_time_range_picker, {
              startDate: _ctx.startDate,
              endDate: _ctx.endDate,
              onSelect: _ctx.setDateRange,
              default: "hari ini",
              showOptions: 
            `${_ctx.$t('custom')},${_ctx.$t('hari ini')},${_ctx.$t('7 hari terakhir')},${_ctx.$t(
              '14 hari terakhir'
            )}`
          ,
              minDate: _ctx.minDate,
              maxDate: _ctx.maxDate,
              onDayClick: _ctx.setDay,
              positionX: -200
            }, null, 8, ["startDate", "endDate", "onSelect", "showOptions", "minDate", "maxDate", "onDayClick"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isConsole)
        ? (_openBlock(), _createBlock("div", {
            key: 2,
            class: `mt-2 ${_ctx.isAgentDexL2 ? 'w-full' : 'w-1/2'}`
          }, [
            _createVNode(_component_MultipleSelectSearch, {
              onFilter: _ctx.getReasonList,
              onChange: _ctx.onSelectReasonType,
              onBlur: _ctx.onBlur,
              options: _ctx.reasonList,
              modelValue: _ctx.reasonValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.reasonValue = $event)),
              placeholder: 
            !_ctx.reasonValue.length
              ? _ctx.$t('dexAssessment.component.filterSelectReason')
              : `${_ctx.reasonValue[0]?.name},${_ctx.reasonValue[1]?.name || ''}...`
          ,
              keyName: "name",
              keyValue: "value",
              isLoading: _ctx.isLoadingDex,
              showReset: "",
              ableToDeleteInModal: "",
              showSelected: false
            }, null, 8, ["onFilter", "onChange", "onBlur", "options", "modelValue", "placeholder", "isLoading"])
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.isAgentDexL2)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_Checkbox, {
              class: "pt-4",
              id: "dispute",
              onChange: _ctx.onCheckbox,
              modelValue: _ctx.isDispute,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDispute = $event)),
              binary: true
            }, null, 8, ["onChange", "modelValue"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("dexAssessment.component.disputeCheckbox")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isAgentDexL2)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_Checkbox, {
              class: "pt-4",
              id: "L1",
              onChange: _ctx.onCheckbox,
              modelValue: _ctx.isL1,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isL1 = $event)),
              binary: true
            }, null, 8, ["onChange", "modelValue"]),
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
      (_ctx.isConsole)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_Checkbox, {
              class: "pt-4",
              id: "dispute",
              onChange: _ctx.onCheckbox,
              modelValue: _ctx.isDEL,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDEL = $event)),
              binary: true
            }, null, 8, ["onChange", "modelValue"]),
            _hoisted_8
          ]))
        : _createCommentVNode("", true),
      (_ctx.isConsole)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode(_component_Checkbox, {
              class: "pt-4",
              id: "L1",
              onChange: _ctx.onCheckRTS,
              modelValue: _ctx.isRTS,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isRTS = $event)),
              binary: true
            }, null, 8, ["onChange", "modelValue"]),
            _hoisted_10
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}